import { useCurrentBox } from "@/modules/box/hooks/useBox"
import { useFinanceStats } from "@/modules/finances/hooks/useFinance"
import { PaymentsToValidateResumeCard } from "@/modules/finances/paymentsToValidate/components/paymentsToValidateResumeCard"
import { PaymentsToValidateTable } from "@/modules/finances/paymentsToValidate/components/paymentsToValidateTable"
import { PaymentsToValidateTableFilter } from "@/modules/finances/paymentsToValidate/components/paymentsToValidateTableFilter"
import { PaymentsToValidateEnumApi } from "@/modules/finances/paymentsToValidate/gateway/paymentsToValidateApi"
import { cn } from "@/modules/lib/utils"
import { StripeAccountStatus } from "@/modules/payment/stripeTypes"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { monthYearDateFormat } from "@/modules/utils/dateUtils"
import dayjs from "dayjs"
import { Suspense } from "react"

export type PaymentsToValidateLayoutProps = {
  className?: string
} & React.ComponentProps<"div">

export function PaymentsToValidateLayout({ className, ...props }: PaymentsToValidateLayoutProps) {
  const { result: box } = useCurrentBox()
  const isStripeAccountComplete = box?.stripeAccountStatus === StripeAccountStatus.OK

  const { data: stats, isLoading } = useFinanceStats(isStripeAccountComplete, dayjs().format(monthYearDateFormat))

  if (isLoading || !stats) return <LoadingSpinner />

  return (
    <div className={cn("flex min-w-250 grow flex-col gap-4", className)} {...props}>
      <PaymentsToValidateResumeCard stats={stats} />

      <div className="flex flex-row flex-wrap items-center justify-between gap-2 md:gap-1 xl:flex-row">
        <PaymentsToValidateTableFilter />
      </div>

      <Suspense fallback={<LoadingSpinner />}>
        <PaymentsToValidateTable
          paymentsToValidateEnumApi={box ? PaymentsToValidateEnumApi.OWNER : PaymentsToValidateEnumApi.ATHLETE}
        />
      </Suspense>
    </div>
  )
}
